'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styled = require('./styled');

var _styles = require('../styles');

var _Message = require('./Message');

var _Message2 = _interopRequireDefault(_Message);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alert = (_temp2 = _class = function (_Component) {
  _inherits(Alert, _Component);

  function Alert() {
    var _temp, _this, _ret;

    _classCallCheck(this, Alert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      timeoutId: null
    }, _this.setSelfDestructTimeout = function () {
      if (!_this.state.timeoutId) {
        var timeoutId = setTimeout(_this.handleOnClose, Alert.timeout);
        _this.setState({ timeoutId: timeoutId });
      }
    }, _this.handleOnClose = function () {
      _this.clearTimeout();
      _this.props.onClose();
    }, _this.clearTimeout = function () {
      if (_this.state.timeoutId) {
        clearTimeout(_this.state.timeoutId);
        _this.setState({ timeoutId: null });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Alert.prototype.componentDidMount = function componentDidMount() {
    if (this.props.selfDestruct && this.props.show) {
      this.setSelfDestructTimeout();
    }
  };

  Alert.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!this.props.show && nextProps.show && nextProps.selfDestruct) {
      this.setSelfDestructTimeout();
    }
  };

  Alert.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearTimeout();
  };

  Alert.prototype.render = function render() {
    var _props = this.props,
        show = _props.show,
        title = _props.title,
        type = _props.type,
        children = _props.children,
        onClose = _props.onClose,
        className = _props.className,
        selfDestruct = _props.selfDestruct,
        largeAlert = _props.largeAlert,
        rest = _objectWithoutProperties(_props, ['show', 'title', 'type', 'children', 'onClose', 'className', 'selfDestruct', 'largeAlert']);

    var Comp = largeAlert ? _styled.LargeWrapper : _styled.BaseWrapper;

    return show && _react2.default.createElement(
      Comp,
      _extends({ className: className }, rest),
      _react2.default.createElement(
        _styled.Header,
        null,
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'close',
            onClick: this.handleOnClose
          },
          _react2.default.createElement(
            'span',
            null,
            '\xD7'
          )
        )
      ),
      _react2.default.createElement(_Icon2.default, {
        name: Alert.typeConfigs[type].name,
        color: Alert.typeConfigs[type].color
      }),
      _react2.default.createElement(
        _Message2.default,
        { title: title },
        children
      )
    );
  };

  return Alert;
}(_react.Component), _class.types = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger'
}, _class.typeConfigs = {
  success: {
    color: _styles.colors.brandSuccess,
    name: 'checkmark-2'
  },
  warning: {
    color: _styles.colors.brandWarning,
    name: 'exclamation-point-2'
  },
  danger: {
    color: _styles.colors.brandDanger,
    name: 'x-2'
  },
  info: {
    color: _styles.colors.brandInfo,
    name: 'info-2'
  }
}, _class.timeout = 5000, _temp2);
Alert.propTypes = process.env.NODE_ENV !== "production" ? {
  show: _propTypes2.default.bool.isRequired,
  title: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.oneOf(['info', 'success', 'warning', 'danger']).isRequired,
  children: _propTypes2.default.node.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  selfDestruct: _propTypes2.default.bool,
  largeAlert: _propTypes2.default.bool
} : {};
exports.default = Alert;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/Alert/index.js
// module id = 885
// module chunks = 14